import React, { useEffect, useState, useRef } from 'react';

import {Popup} from 'react-map-gl';
import { Button, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMap } from 'react-map-gl';
import { useDispatch } from 'react-redux';

import { setAlert } from '../store/actions/alertActions';
import { setDirectionsOrigin } from '../store/actions/directionsActions';
import { getGeolocationPermission } from '../hooks/useGeoLocation';

const LONG_PRESS_THRESHOLD = 500; // ms

export const PopupMap = (props) => {

  const [showPopup, setShowPopup] = useState(false);
  const [lngPopup, setLngPopup] = useState(null);
  const [latPopup, setLatPopup] = useState(null);
  const longPressTimeout = useRef(null);
  const {mymap} = useMap();
  const {t} = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    mymap?.on('contextmenu', handlePopup);
    mymap?.on('touchstart', checkLongPress);
    mymap?.on('touchend', clearLongPress);
    mymap?.on('touchmove', clearLongPress);
    mymap?.on('touchcancel', clearLongPress);
    mymap?.on('movestart', clearLongPress);
    return () => {
      mymap?.off('contextmenu', handlePopup);
      mymap?.off('touchstart', checkLongPress);
      mymap?.off('touchend', clearLongPress);
      mymap?.off('touchmove', clearLongPress);
      mymap?.off('touchcancel', clearLongPress);
      mymap?.off('movestart', clearLongPress);
    };
  }, [mymap]);

  const clearLongPress = () => clearTimeout(longPressTimeout.current);

  const checkLongPress = (e) => {
    const isMultiTouchEvent = e && e.points.length > 1;
    if (!isMultiTouchEvent) {
      longPressTimeout.current = setTimeout(() => handlePopup(e), LONG_PRESS_THRESHOLD);
    }
  };

  const handlePopup = (e) => {
    if (showPopup){ 
      setShowPopup(false);
    }
    setLngPopup(e.lngLat.lng);
    setLatPopup(e.lngLat.lat);
    setShowPopup(true);
  };

  const handleButtonClick = (dest) => {
    props.setMarker([lngPopup, latPopup], dest);
    setShowPopup(false);
  };

  const fromMyLocation = () => {
    dispatch(setDirectionsOrigin([], t('common.search-position')));
    getGeolocationPermission().then((result) => {
      if (result.state === 'denied') {
        dispatch(setAlert(t('error.error-geolocation'), 'error',  t('error.label'), 'alert'));
      } else  {
        navigator.geolocation.getCurrentPosition( pos => {
          const value = {longitude: pos.coords.longitude, latitude: pos.coords.latitude};
          if (value !== null && typeof value === 'object') {
            const center = value.longitude && value.latitude ? [value.longitude, value.latitude] : null;
            dispatch(setDirectionsOrigin(center, t('common.location-mark')));
          } else {
            dispatch(setAlert(t('error.error-place-origin-feature'), 'error',  t('error.label'), 'alert'));
            dispatch(setDirectionsOrigin([], ''));
          }
        }, (error) => {
          if(error.code == 1) {
            // Error: Access is denied!
            dispatch(setAlert(t('error.error-geolocation'), 'error',  t('error.label'), 'alert'));
            dispatch(setDirectionsOrigin([], ''));
          } else if( error.code == 2) {
            // "Error: Position is unavailable!"
            dispatch(setAlert(t('error.error-place-origin-feature'), 'error',  t('error.label'), 'alert'));
            dispatch(setDirectionsOrigin([], ''));
          }
        });
      }
    });
    handleButtonClick('destination');
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
      {showPopup && <Popup
        latitude={latPopup}
        longitude={lngPopup}
        closeButton={true}
        closeOnClick={false}
        maxWidth="300px"
        onClose={() => setShowPopup(false)}
      >
        <div>
          <Button sx={{fontSize: '1em', textAlign: 'start'}} id='set-origin' onClick={() => handleButtonClick('origin')} size="small">{t('popup.deaparture')}</Button>
        </div>
        <Divider aria-hidden={true} sx={{ marginBottom: '1em' }}/>
        <div>
          <Button sx={{fontSize: '1em', textAlign: 'start'}} id='set-destination' onClick={() => handleButtonClick('destination')} size="small">{t('popup.arrival')}</Button>
        </div>
        <Divider aria-hidden={true} sx={{ marginBottom: '1em' }}/>
        <div>
          <Button sx={{fontSize: '1em', textAlign: 'start'}} id='set-dest-from-geo' onClick={() => fromMyLocation()} size="small">{t('popup.from-position')}</Button>
        </div>
      </Popup>}
    </div>
  );
};
